import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

function Stat({ label, value, testid }) {
  return (
    <div className="rounded-xl bg-card border border-white/10 p-4" data-testid={testid}>
      <div className="text-3xl heading font-extrabold text-primary">{value}</div>
      <div className="text-xs text-muted-foreground">{label}</div>
    </div>
  );
}

export default function AdminStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setS(data)).catch((e) => toast.error(formatApiError(e))); }, []);
  if (!s) return <p className="text-sm text-muted-foreground">Carregando...</p>;
  return (
    <div className="space-y-4" data-testid="admin-stats">
      <p className="text-xs text-muted-foreground">Últimos 7 dias</p>
      <div className="grid grid-cols-2 gap-2">
        <Stat label="Novos usuários" value={s.users} testid="stat-users" />
        <Stat label="Rolês criados" value={s.events} testid="stat-events" />
        <Stat label="Jogos criados" value={s.games} testid="stat-games" />
        <Stat label="Confirmações" value={s.confirmations} testid="stat-confirmations" />
      </div>
      <div className="rounded-xl bg-card border border-white/10 p-4">
        <div className="text-sm font-semibold mb-2">Cliques por adega</div>
        {s.adegas.length === 0 && <p className="text-xs text-muted-foreground">Sem cliques nesta semana.</p>}
        <table className="w-full text-xs">
          {s.adegas.length > 0 && <thead><tr className="text-muted-foreground text-left"><th className="py-1">Adega</th><th>Catálogo</th><th>WhatsApp</th><th>Como chegar</th></tr></thead>}
          <tbody>{s.adegas.map((a) => <tr key={a.adega_id} className="border-t border-white/5" data-testid={`stat-adega-${a.adega_id}`}><td className="py-1.5">{a.name}</td><td>{a.catalog}</td><td>{a.whatsapp}</td><td>{a.directions}</td></tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}
